import Button from "@material-ui/core/Button";
import EmailIcon from "@mui/icons-material/Email";
import React, { Component } from "react";

export class EmailIconButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      domainObject: props.onClick,
      onClick: props.onClick,
      caption: props.caption,
    };
  }

  onClick() {
    if (this.state.onClick) {
      this.state.onClick();
    }
  }
  render() {
    return (
      <span
        onClick={this.onClick.bind(this)}
        style={{
          cursor: "pointer",
          fontSize: "x-larger",
          marginRight: "0.5em",
          float: "right",
        }}
      >
        <Button
          variant="contained"
          // size="small"
          style={{
            background: "#d3d8de",
            color: "#353538",
            marginRight: "1rem",
            float: "right",
            textTransform: "capitalize",
            padding: "2px 10px",
          }}
          startIcon={<EmailIcon />}
        >
          Test Email
        </Button>
      </span>
    );
  }
}
export default EmailIconButton;
